import Vue from 'vue'
import vuetify from '@/plugins/vuetify'
import './plugins'
import './plugins/stylus/main.styl'
import App from './App.vue'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import router from './router'
import store from '@/store'
import messages from '@/lang/messages'
import VueI18n from 'vue-i18n'
import 'leaflet/dist/leaflet.css'
import { Icon } from 'leaflet'

delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  store,
  data: () => ({ loading: true }),
  mounted() {
    this.loading = false
  },
  i18n: new VueI18n({
    fallbackLocale: 'fr_FR',
    locale: (navigator.language || 'fr_FR').replace('-', '_'),
    silentTranslationWarn: true,
    messages,
  }),

  onIdle() {
    if (this.$auth.loggedWithoutCheckConfirmAuth()) {
      this.$auth.logout()
    }
  },

  render: (h) => h(App),
}).$mount('#app')
